import logo from '../../../files/system/logo.png';
function Footer() {
  return (
    <div className='block_footer'>
      <div className='block block_01'>
        <div className="row">
          <div className="col-lg-4">
            <div className='block_footer_logo'>
              <img src={logo} className='logo'></img>
              <div>
                <div className='block_footer_logo_title'>BIZ-Трекер задач</div>
                <div className='block_footer_logo_description'>Легкий сервис для работы с задачами</div>
              </div>
            </div>
          </div>
          <div className="col-lg-4"></div>
        </div>
      </div>
    </div >
  );
}

export default Footer;
